import './ec-pie.css';

let ecPie = ({ dom, data, echarts }) => {
    // 数据处理与准备
    let duration = 2100;

    ecPie.destroy = () => {
        echarts.dispose(dom);
        window.removeEventListener('resize', resizeChartPie);
    };

    let myChart = echarts.init(dom);
    function resizeChartPie() {
        if (myChart) {
            myChart.resize();
        }
    }
    window.addEventListener('resize', resizeChartPie);

    let num = data[0].count / (data[0].count + data[1].count + data[2].count);
    if (isNaN(num)) {
        num = 0;
    }
    let scale = window._scale || 1;
    let titleColor = window._screenType === '2160' ? '#3E79D4' : '#D6B30D';
    // 指定图表的配置项和数据
    let option = {
        title: {
            text: `${(num * 100).toFixed(0)}%`,
            x: 'center',
            y: 'center',
            textStyle: {
                fontWeight: 'bold',
                // color: '#E9F2FF',
                color: titleColor,
                fontSize: scale * '16'
            }
        },
        tooltip: {
            show: true,
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)',
            textStyle: {
                // color: titleColor,
                fontSize: scale * 14
            }
        },
        series: [{
            animationDuration: duration,
            type: 'pie',
            hoverOffset: 1,
            radius: ['75%', '95%'],
            avoidLabelOverlap: false,
            label: {
                normal: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    show: false,
                    textStyle: {
                        fontSize: '14',
                        color: '#E9F2FF',
                    },
                    formatter: '{b} ({d}%)',
                }
            },
            labelLine: {
                normal: {
                    show: true
                }
            },
            data: data.map((item, index) => {
                // 放到外面
                let itemStyleArr = [
                    {
                        color: {
                            type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                            colorStops: [{ offset: 0, color: 'rgba(255,247,154,1)', }, { offset: 1, color: 'rgba(223,151,45,1)', }],
                            globalCoord: false // 缺省为 false
                        },
                        // borderColor: 'rgba(255,241,219,0.22)'
                    },
                    { color: 'rgba(248,231,28,0.4)', },
                    { color: '#06323b', }
                ];

                let otherItemStyleArr = [
                    { color: '#B99900' },
                    { color: '#463F1A', },
                    { color: '#151928', }
                ];

                return {
                    value: item.count,
                    name: item.name,
                    itemStyle: window._screenType === '2160' ? itemStyleArr[index] : otherItemStyleArr[index],
                    // selected: index === 0,
                }
            }),
        }]
    };

    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option);
    return ecPie;
};

export default ecPie;
